import logo from "./logos/logo.svg"
import logo_white from "./logos/logo_white.svg"

export const Images = {
    logo,
    logo_white
}